import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Grid, GridColumn, List, ListItem, Notice, Spinner } from 'telia-front-react';

import InvoiceDetailsStore from '../../stores/InvoiceDetailsStore';
import { formatDate } from '../../util/DateUtil';
import { ITranslateStore } from '../../stores/TranslateStore';
import { InvoiceDeliveryLog } from '../../stores/models/InvoiceDeliveryLog';
import InvoiceDeliveryLogDataStore from '../../stores/data/InvoiceDeliveryLogDataStore';

interface IInvoiceDeliveryLogNoticeProps {
  invoiceDeliveryLogDataStore?: InvoiceDeliveryLogDataStore;
  invoiceDetailsStore?: InvoiceDetailsStore;
  translateStore?: ITranslateStore;
}

@inject('invoiceDeliveryLogDataStore', 'invoiceDetailsStore', 'translateStore')
@observer
export default class InvoiceDeliveryLogNotice extends React.Component<IInvoiceDeliveryLogNoticeProps> {
  public componentDidMount(): void {
    this.props.invoiceDeliveryLogDataStore.tryLoadInvoiceDeliveryLog(this.props.invoiceDetailsStore.currentInvoiceNumber);
  }

  public render(): JSX.Element {
    const invoiceNumber = this.props.invoiceDetailsStore.currentInvoiceNumber;
    const invoiceDeliveryLog = this.props.invoiceDeliveryLogDataStore.deliveryLogs.get(invoiceNumber);

    if (!invoiceDeliveryLog) {
      return null;
    }

    if (invoiceDeliveryLog.isLoading) {
      return <Spinner />;
    }

    if (invoiceDeliveryLog.isFinished) {
      const listOfLogItems = [];
      invoiceDeliveryLog.payload.forEach((log, index) =>
        listOfLogItems.push(
          <ListItem key={`delivery-notice-${index}`} className="text-center">
            <Notice size="small" align="center">
              <span dangerouslySetInnerHTML={this.getIndividualLogLines(log)} />
            </Notice>
          </ListItem>
        )
      );
      return (
        <Grid>
          <GridColumn width={['max']}>
            <List type="unstyled">{listOfLogItems}</List>
          </GridColumn>
        </Grid>
      );
    }
    return <React.Fragment />;
  }

  public getIndividualLogLines(invoiceDeliveryLog: InvoiceDeliveryLog): any {
    const translateHtml = this.props.translateStore.translateHtml;
    return translateHtml(`shared.invoice-details-modal.delivery-log.${invoiceDeliveryLog.channelType}`, {
      date: formatDate(invoiceDeliveryLog.date),
      channelAddress: invoiceDeliveryLog.channelAddress
    });
  }
}
